import { css } from "@emotion/css";
import cx from "classnames";
import React, { useMemo } from "react";

import { useLayout } from "./Layout";
import { mq } from "../../components/utils";
interface Props {
  span?: number | "auto" | number[];
  alignItems?: React.CSSProperties["alignItems"];
  className?: string;
  children?: React.ReactNode;
  testID?: string;
  ["aria-label"]?: string;
}

export function GridItem(props: Props) {
  const {
    span = "auto",
    alignItems,
    className,
    children,
    testID = "grid-item",
  } = props;

  const {
    layoutValues: { columns },
  } = useLayout();

  const gridSpan = useMemo(() => {
    return css(calculateSpan(span, columns));
  }, [span, columns]);

  return (
    <section
      aria-label={props["aria-label"]}
      className={cx("grid-item", styles.section, gridSpan, className)}
      style={{
        alignItems,
      }}
      data-testid={testID}
    >
      {children}
    </section>
  );
}

function calculateSpan(span: Props["span"], totalCols = 12) {
  if (!span || span === "auto") {
    return {
      gridColumnStart: 1,
      gridColumnEnd: totalCols + 1,
    };
  }

  const parsedSpan = Array.isArray(span) ? span : [span];

  return mq({
    gridColumnEnd: parsedSpan.map((col) => `span ${col}`),
  });
}

const styles = {
  section: css({
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  }),
};
